import theme from "@shared/utils/themeColors";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import SignupForm from "../components/SignupForm";
import { useAuth } from "../hooks/useAuth";

// Main signup page component
const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [position, setPosition] = useState("");
  const [invitationId, setInvitationId] = useState<string | null>(null);
  const [hasValidInvitation, setHasValidInvitation] = useState<boolean>(false);
  const { register, loading, error } = useAuth();
  const navigate = useNavigate();

  // Check for invitation ID in session storage
  useEffect(() => {
    const storedInvitationId = sessionStorage.getItem("invitationId");
    const storedEmail = sessionStorage.getItem("invitationEmail");

    if (storedInvitationId) {
      setInvitationId(storedInvitationId);
      setHasValidInvitation(true);

      // The account has to be created for the address that was invited — the
      // backend refuses anything else — so it is filled in and locked rather
      // than left for the person to retype and get wrong.
      if (storedEmail) {
        setEmail(storedEmail);
      }
    } else {
      // Redirect to invitation page if no invitation ID is found
      navigate("/invitation");
    }
  }, [navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      return;
    }

    // Only register if there's a valid invitation
    if (hasValidInvitation && invitationId) {
      await register(email, password, fullName, position);
    }
  };

  return (
    <AuthLayout>
      {!hasValidInvitation ? (
        <div className="text-center py-8">
          <h1 className={`text-3xl ${theme.text.primary} mb-6 font-petrona`}>
            Invitation Required
          </h1>
          <p className="mb-6">
            You need a valid invitation to register for this platform.
          </p>
          <button
            onClick={() => navigate("/signin")}
            className={`px-4 py-2 rounded ${theme.button.primary.base} ${theme.button.primary.dark}`}
          >
            Back to Sign In
          </button>
        </div>
      ) : (
        <SignupForm
          email={email}
          setEmail={setEmail}
          emailLocked={!!sessionStorage.getItem("invitationEmail")}
          password={password}
          setPassword={setPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          fullName={fullName}
          setFullName={setFullName}
          position={position}
          setPosition={setPosition}
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
        />
      )}
    </AuthLayout>
  );
};

export default SignupPage;
